var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GridPage',{attrs:{"form-default":{
            status: 'pending',
        },"filters-default":{
            status: '',
            sort: 'name',
        },"filter-items":[
            {
                vModel: 'status',
                title: '状態',
                options: [
                    { text: '全て', value: '' },
                    { text: '準備', value: 'pending' },
                    { text: '受付', value: 'activated' },
                    { text: '締切', value: 'closed' } ],
            },
            {
                vModel: 'sort',
                title: '順番',
                options: [
                    {
                        text: '▲ 名前',
                        value: 'name',
                    },
                    { text: '▼ 名前', value: '-name' } ],
            } ],"filters-q-placeholder":"名前","form-modal-id":"form","search-action":"form/index"},scopedSlots:_vm._u([{key:"form",fn:function(ref){
        var form = ref.form;
        var init = ref.init;
return [_c('Form',{attrs:{"model":form,"init":init}})]}},{key:"column",fn:function(ref){
        var item = ref.item;
return [_c('b-col',{staticClass:"align-self-center",attrs:{"md":"6"}},[_c('FormBadges',{staticClass:"mb-1",attrs:{"model":item}}),_vm._v(" "),_c('p',{staticClass:"mb-1"},[_vm._v("\n                    "+_vm._s(item.name)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"mb-1"},[_c('FormDate',{attrs:{"model":item}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"align-self-center",attrs:{"md":"6"}},[_c('FormInfo',{attrs:{"model":item}})],1)]}}])},[_vm._v(" "),[_c('b-col',{attrs:{"md":"6"}},[_vm._v(" 名前 ")]),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_vm._v(" メール ")])]],2),_vm._v(" "),_c('b-link',{attrs:{"href":("/f/" + _vm.auth_uuid + "/"),"target":"_blank"}},[_vm._v("\n        公開ページを表示する\n        "),_c('font-awesome-icon',{staticClass:"fa-fw",attrs:{"icon":"external-link-alt"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }